import usePrivateAxios from "@/common/api/usePrivateAxios"
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant"
import { Mapper } from "@/common/services/mapper"
import { MetaResponse } from "@/common/types/metaResponse"
import { keepPreviousData, useQuery } from "@tanstack/react-query"

type UsePosProps<T> = {
  filters?: {
    search?: string
    page?: number
    status?: string
    establishmentCompanyBranchId?: string

  }
  mapper?: (data: any) => T,
}

export const usePosMachines = <T,>({
  filters: { search = '', page, status, establishmentCompanyBranchId, } = {},
  mapper = Mapper.default<T>(),
}: UsePosProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['posMachines', search, page, status, establishmentCompanyBranchId],
    queryFn: () => {
      return privateAxios.get('/pos/machines', {
        params: {
          search,
          page,
          'q[status_eq]': status,
          'q[establishment_company_branch_id_eq]': establishmentCompanyBranchId,
        }
      })
    },
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  })
  return { data, meta, isPending, ...rest }
}
